import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { ProvaScrittaAdapter } from '../../components/fascicolo/prove-scritte-update/prova-scritta-adapter';
import { ProvaScritta } from '../../models/prova-scritta';
import { StatoEntita } from '../../models/tipologiche/stato-entita';
import { BaseForm } from '../base-Form';

declare var removeEmptyObject: any;

export abstract class ProveScritteFormComponent extends BaseForm {

  request: ProvaScritta;
  provaScrittaForm: FormGroup;
  tipoProvaScrittaOptions: StatoEntita[] = [];

  abstract getProvaScritta(): ProvaScritta;
  abstract getRequest(request: ProvaScritta);

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  createForm() {
    this.request = new ProvaScrittaAdapter(this.getProvaScritta()).provaScritta;
    this.provaScrittaForm = this.campiForm.group({
      scadenza: [this.request.scadenza],
      valore: [this.request.valore],
      descrizione: [this.request.descrizione],
      tipoProvaScritta: [this.request.tipoProvaScritta, Validators.required],
      note: [this.request.note],
    });
  }

  update() {
    this.getRequest(this.request);
  }

  populateSelect() {
    if (this.tipoProvaScrittaOptions.length === 0) {
      this.helpers.getTipiProvaScritta().subscribe(response => this.tipoProvaScrittaOptions = response);
    }
  }
}
